export const BlankCircuitChildren: any = [{ attrs: {}, className: "Layer", children: [] }];